export const complaintsPolicyPath = '/complaints-policy';
